<template lang="pug">
  div
    div
      i(:class="$style.maintitle" class="el-icon-user")
      span(:class="$style.maintitle") {{ username }}
      i(
        v-if="isStudent && !license.ok"
        class="fa fa-exclamation-circle" 
        style="color:#ef5350; padding-left:5px")

    el-card(v-if="display" :class="$style.card")
        // Header
        div(slot="header" :class="$style.cardInfo" style="display:flex;")
          div(style="margin-left:20px;")
            i(class="fa fa-envelope" style="padding-right: 10px; font-size: 15px")
          span(:class="$style.subtitle") {{ email || '-' }}      

        // Links
        div(:class="$style.cardContent")
          a(href="#" @click="$emit('onShowPasswordChange')")
            div
              i(class="fa fa-key" style="padding-right: 10px")
              span Change Password
          a(v-if="isStudent" href="#"  @click="$emit('onShowSubscription')")
            div
              i(class="fa fa-id-card-o" style="padding-right: 10px")
              span License &nbsp
              span(
                :class="license.ok? $style.valid : $style.expired"
              ) {{ license.label }}
          a(href="#" @click="logout")
            div
              i(class="fa fa-power-off" style="padding-right: 10px")
              span Sign out
</template>

<script>
  import { mapState } from 'vuex'
  import { ACTION_LOGOUT } from '@/store/actions'
  import { TYPE_STUDENT } from 'globalUtils/constants'

  import {
    PAGE_LOGIN,
  } from '@/student/router/routeNames'

  export default {
    name: 'Profile',

    props: {
      username: {
        type: String,
        default: '-',
      },
      email: {
        type: String,
        default: '-',
      },
      show: {
        type: Boolean,
        default: false,
        required: true,
      },
    },

    computed: {
      ...mapState({
        isStudent: state => state.user.user.kind === TYPE_STUDENT,
        user: state => state.user.user,
      }),

      display() {
        return this.show
      },

      license() {
        let ok = true
        let label = '(FREE ACCESS)'
        if (this.user.expiryDate) {
          const end = new Date(this.user.expiryDate)
          const mDate = new Date()
          mDate.setMonth(mDate.getMonth() + 1)
          const endFormatted = `${end.getFullYear()}-${end.getMonth() + 1}-${end.getDate()}`
          if (end < mDate) {
            ok = false
            label = `(Expiring on ${endFormatted})`
          } else {
            label = `(Valid until ${endFormatted})`
          }
        }
        return { ok, label }
      },
    },

    methods: {
      logout() {
        this.$store.dispatch(ACTION_LOGOUT)
          .then(() => {
            this.$router.push({ name: PAGE_LOGIN })
          })
      },
    },
  }
</script>

<style module>
  .maintitle {
    color: var(--button-blue);
    font-weight: 700;
    word-wrap: break-word;
  }

  .subtitle {
    font-size: 15px;
    font-weight: 500;
    padding-left: 5px;
    width:210px;
    text-align: justify;
    overflow: hidden; 
    text-overflow: ellipsis;
  }

  .card {
    width: 260px;
    min-height: 60px;
    position: absolute;
    right: 0px;
    top: 60px;
    z-index: 9999;
    font-size: 14px;
    margin: 0;
   
    & a {
      text-decoration: none;
    }   
  }

  .cardInfo {
    word-wrap: break-word;
    color: #fff;
    min-height: 20px;
    background-color: var(--button-blue);
    margin: -20px;
  }

  .cardContent {
    line-height: 45px;
    margin: -20px -20px -20px -20px;

    & div {
      border-bottom: 0.5px solid #EBEEF5;
      text-align: left;
      padding-left: 20px;
    }

    & div:hover {
      background-color: #F2F6FC;
    }
  }

  .expired {
    color: var(--warning);
    font-size: 0.9em;
    font-weight: 600;
  }

  .valid {
    color: var(--button-blue);
    font-size: 0.9em;
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// client/components/Profile/Profile.vue